import { vueAppSelMode } from '@/config'

let linkFetchUrl = 'https://fgproduction.api-fillgoods.com'
let linkFetchUrlFinance = 'https://fgprod-finance.api-fillgoods.com'
let linkFetchUrlFbLive = 'https://live-prod.api-fillgoods.com/api/live'
let nodeServerUrl = 'https://njs.api-fillgoods.com'

const firebaseConfig = {
    apiKey: 'AIzaSyB41p_Jwq4Tx5MOxuo3Q23MLsvJwkQcKq0',
    authDomain: 'fillgoods-oms.firebaseapp.com',
    databaseURL: 'https://fillgoods-oms.firebaseio.com',
    projectId: 'fillgoods-oms',
    storageBucket: 'gs://fillgoods-oms.appspot.com'
}

const firebaseFillgoods = {
    dev: {
        apiKey: 'AIzaSyDs_SwAN5DQm-MOKWrbIYL1UIdgScg3M7k',
        authDomain: 'fillgoods-dev.firebaseapp.com',
        databaseURL: 'https://fillgoods-dev.firebaseio.com',
        projectId: 'fillgoods-dev',
        storageBucket: 'fillgoods-dev.appspot.com',
        messagingSenderId: '1023151727444',
        appId: '1:1023151727444:web:d54575a815a3efdd319ec1'
    },
    uat: {
        apiKey: 'AIzaSyDGyhsoYSfoQdxuDe8_u0if4xgzqLWK0XY',
        authDomain: 'fillgoods-uat.firebaseapp.com',
        databaseURL: 'https://fillgoods-uat.firebaseio.com',
        projectId: 'fillgoods-uat',
        storageBucket: 'fillgoods-uat.appspot.com',
        messagingSenderId: '650008210379',
        appId: '1:650008210379:web:9c58f188c25fe34363644e'
    },
    prod: {
        apiKey: 'AIzaSyBK8_BSVeoN6QyD-macXqVXmln9qczq4FQ',
        authDomain: 'fillgoods-prod.firebaseapp.com',
        databaseURL: 'https://fillgoods-prod.firebaseio.com',
        projectId: 'fillgoods-prod',
        storageBucket: 'fillgoods-prod.appspot.com',
        messagingSenderId: '637641960049',
        appId: '1:637641960049:web:0267a9bd96687e5a5789d0'
    },
    oms: {
        apiKey: 'AIzaSyB41p_Jwq4Tx5MOxuo3Q23MLsvJwkQcKq0',
        authDomain: 'fillgoods-oms.firebaseapp.com',
        databaseURL: 'https://fillgoods-oms.firebaseio.com',
        projectId: 'fillgoods-oms',
        storageBucket: 'fillgoods-oms.appspot.com',
        messagingSenderId: '1013553473749',
        appId: '1:1013553473749:web:d86874cc9a16e20f'
    },
    omsDev: {
        apiKey: 'AIzaSyCKJ_SfaORBgbFQMSkwtzmEmGD60AI48TU',
        authDomain: 'fillgoods-oms-dev.firebaseapp.com',
        databaseURL: 'https://fillgoods-oms-dev.firebaseio.com',
        projectId: 'fillgoods-oms-dev',
        storageBucket: 'fillgoods-oms-dev.appspot.com',
        messagingSenderId: '1028897815174',
        appId: '1:1028897815174:web:caa2936806ffced8'
    }
}

const configEnvEndpoint = () => {
    if (vueAppSelMode === 'dev') {
        linkFetchUrl = 'https://fgstaging.api-fillgoods.com'
        linkFetchUrlFinance = 'https://fgstaging-finance.api-fillgoods.com'
        linkFetchUrlFbLive = 'https://live-staging.api-fillgoods.com/api/live'
        nodeServerUrl = 'https://njs-staging.api-fillgoods.com'
    } else if (vueAppSelMode === 'uat') {
        linkFetchUrl = 'https://fguat.api-fillgoods.com'
        linkFetchUrlFinance = 'https://fguat-finance.api-fillgoods.com'
        linkFetchUrlFbLive = 'https://live-uat.api-fillgoods.com/api/live'
        nodeServerUrl = 'https://njs-uat.api-fillgoods.com'
    }

    return {
        env: vueAppSelMode,
        firebaseConfig,
        linkFetchUrl,
        firebaseFillgoods,
        linkFetchUrlFinance,
        linkFetchUrlFbLive,
        nodeServerUrl
    }
}

const serverConfig = configEnvEndpoint()

export { serverConfig }
